/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_Broker_PendingInputs */

const cs_ebr_pairing_broker_pending = /** @type {(inputs: Ebr_Pairing_Broker_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`makléř vznikne`)
};

const en_ebr_pairing_broker_pending = /** @type {(inputs: Ebr_Pairing_Broker_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`broker to be created`)
};

/**
* | output |
* | --- |
* | "broker to be created" |
*
* @param {Ebr_Pairing_Broker_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_broker_pending = /** @type {((inputs?: Ebr_Pairing_Broker_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_Broker_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_broker_pending(inputs)
	return cs_ebr_pairing_broker_pending(inputs)
});